<script>
  export default {
    data() {
      return {
        autorizado: false,
        mostrarBusca: false,
        termoBusca: '',
        mostrarUserMenu: false
      };
    },
    created() {
      const auth = this.$store.getters['auth/getAuth']
      if(auth.token){
        this.autorizado = true
      }
    },
    methods: {
      logout(){
        this.$store.dispatch('auth/logout')
        window.location.reload()
      },
      toggleBusca() {
        this.mostrarBusca = !this.mostrarBusca
      },
      buscarTermo(){
        this.toggleBusca()
        const pesquisa = this.termoBusca
        console.log(pesquisa)
        this.$router.push('/pesquisa/' + pesquisa)
      },
      paginaHome() { 
        this.$router.push('/')
      },
      toggleUserMenu() {
        this.mostrarUserMenu = !this.mostrarUserMenu;
      },
      modalSugestao() {
        this.$swal.fire({
          title: 'Deixar sujestão!',
          text: '"Sentiu falta de algum material? deixe sua sugestão e iremos providenciar assim que possível!"',
          input: "textarea",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: 'Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async (sugestao) => {
            try {
              console.log(sugestao)
              this.$store.dispatch('modulos/deixarSugestao', { data: sugestao })
              this.$swal.fire('Obrigado!', 'Sua sugestão foi enviada com sucesso.', 'success')
            } catch (error) {
            }
          }
        })
      }
    }
  }
</script>
<style lang="scss" src="./style.scss" scoped></style>
<template>
  <div>
    <nav class="row nav-menu">
      <div class="logo col-2" @click="paginaHome()" style="cursor: pointer">
        <img class="img-logo" src="@/assets/images/logo_branca.png" alt="" />
      </div>
      <div class="links-menu col-10">
        <a href="/">Início</a>
        <a href="/#categorias">Sobre</a>
        <a href="/#cursos">Cursos</a>
        <a href="/#novidades">Novidades</a>
        <a href="/#contato">Contato</a>
        <a v-if="!autorizado" href="/entrar">Entrar</a>
        <!-- <button class="btn btn-outline-light" v-if="autorizado" @click="logout">Deslogar</button> -->

        <transition name="fade-expand">
          <input v-if="mostrarBusca" type="text" class="input-busca" v-model="termoBusca" placeholder="Buscar..." />
        </transition>
        <button class="btn" v-if="mostrarBusca" @click="buscarTermo()"><i class="bi bi-send"></i></button>

        <button class="btn" v-if="mostrarBusca" @click="toggleBusca">
          <i class="bi bi-x-lg"></i>
        </button>
        <button class="btn" v-if="!mostrarBusca" @click="toggleBusca">
          <i class="bi bi-search"></i>
        </button>

        <div class="user-menu" v-if="autorizado">
          <button class="btn text-white" @click="toggleUserMenu">
            <i class="bi bi-person-circle"></i>
          </button>

          <div class="dropdown-user" v-show="mostrarUserMenu">
            <!-- <a v-if="!autorizado" @click="$router.push('/entrar'), toggleUserMenu()"> Entrar</a> -->
            <a v-if="autorizado" @click="logout(), toggleUserMenu()"><i class="bi bi-box-arrow-right"></i> Deslogar</a>
            <a v-if="autorizado" @click="modalSugestao(), toggleUserMenu()"><i class="bi bi-chat"></i> Deixar sugestão</a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
